import { AlertTriangle, Info } from "lucide-react";

const today = () => new Date().toISOString().slice(0, 10);

/** Legality status for an official search result in the deck's official format (Scryfall legality + release date). */
export function officialStatus(card, formatKey) {
  const s = card.legalities?.[formatKey];
  if (!formatKey || !s || s === "legal") return null;
  if (s === "banned") return { code: "banned", severity: "error", label: "Banned" };
  if (s === "restricted") return { code: "restricted", severity: "info", label: "Restricted: 1 copy" };
  if (card.released_at && card.released_at > today()) return { code: "not_released", severity: "error", label: `Not released yet: ${card.released_at}` };
  return { code: "not_legal", severity: "error", label: "Not legal" };
}

export function IssueBadge({ issue, testid }) {
  const err = issue.severity === "error";
  const Icon = err ? AlertTriangle : Info;
  return (
    <span className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-semibold ${err ? "bg-red-950/70 text-red-200 ring-1 ring-red-800/60" : "bg-slate-800 text-slate-300 ring-1 ring-slate-700"}`} data-testid={testid}>
      <Icon className="h-3 w-3 shrink-0" />{issue.label}
    </span>
  );
}
